import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { clearStore, setCausesList } from 'store/bonoBot/bonoBot.slice';
import { causesState } from 'store/causes/causes.slice';
import { routes } from 'routes/routes';

const HeaderButtons = () => {
   const dispatch = useAppDispatch();
   const navigate = useNavigate();
   const { causesList } = useAppSelector(causesState);
   const handleStartOver = () => {
      dispatch(clearStore());
      dispatch(setCausesList(causesList));
      navigate(routes().bonoBot.main);
   };
   return (
      <Box sx={{ display: 'flex', flexDirection: 'row', columnGap: '10px' }}>
         <Button
            onClick={handleStartOver}
            sx={{
               backgroundColor: '#f7e5e3',
               '&:hover': {
                  backgroundColor: '#ffffff',
               },
               py: 0.75,
               px: 1.5,
               width: 'fit-content',
               height: 'fit-content',
               maxWidth: 'unset',
               minWidth: 'unset',
               borderRadius: '99px',
               border: '1px solid #E5E5E5',
            }}
         >
            <Typography
               sx={{
                  color: '#666666',
                  fontSize: '12px',
                  lineHeight: '14px',
                  fontWeight: 600,
                  whiteSpace: 'nowrap',
                  textTransform: 'none',
               }}
            >
               Start over
            </Typography>
         </Button>
         {/* <Button
            sx={{
               backgroundColor: '#FFFFFF',
               py: 0.75,
               px: 1.5,
               width: 'fit-content',
               height: 'fit-content',
               maxWidth: 'unset',
               minWidth: 'unset',
               borderRadius: '99px',
               border: '1px solid #E5E5E5',
            }}
         >
            <Typography
               sx={{
                  color: '#666666',
                  fontSize: '12px',
                  lineHeight: '14px',
                  fontWeight: 600,
                  whiteSpace: 'nowrap',
                  textTransform: 'none',
               }}
            >
               Login
            </Typography>
         </Button> */}
      </Box>
   );
};

export default HeaderButtons;
